import { toast } from "react-toastify";
import { getApiBaseUrl } from '../utils/apiBaseUrl';

export interface RejectApiAccessResponse {
  message: string;
}

export const rejectApiAccessRequest = async (
  token: string,
  userId: number,
  t: (key: string) => string
): Promise<RejectApiAccessResponse> => {
  if (!token) {
    throw new Error("Token not found");
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Admin/RejectApiAccessRequest/${userId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to reject API access request");
    }

    const data: RejectApiAccessResponse = await response.json();
    return data;
  } catch (error) {
    toast.error(t("somethingWentWrong"));
    throw error;
  }
};